'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'person-rays';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e54d';
var svgPathData = 'M256 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM176 186.1c-1.1 1.6-2.2 3.3-3.2 5L109.7 296.2c-4.5 7.6-14.4 10-22 5.5s-10-14.4-5.5-21.9l63.1-105.1C168.7 135.8 210.7 112 256 112s87.3 23.8 110.6 62.6l63.1 105.1c4.5 7.6 2.1 17.4-5.5 21.9s-17.4 2.1-22-5.5L339.2 191.1c-1-1.7-2.1-3.4-3.2-5L336 528c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160-96 0 0 160c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-341.9zm128-29.4c-14.4-8.2-30.9-12.7-48-12.7s-33.6 4.5-48 12.7l0 179.3 96 0 0-179.3zM4.7 4.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6zm502.6 0c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0zM27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96zm480 0c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPersonRays = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;